module.exports = __webpack_public_path__ + "static/media/survey_icon_selected.8e35f240.svg";